import { FC } from "react";
import SmartSearchAndActionsLayout from "../../../components/Layouts/smart-search-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import {
  GetReportCurrentInventoryParams,
  getReportCurrentInventory,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import {ValidationEnum} from "../../../enums/validationEnum";

const ReportCurrentInventory: FC = () => {
  return (
    <SmartSearchAndActionsLayout
      searchBy={[
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_PDF,
        ActionButtonEnum.SAVE_CSV,
      ]}
      validations={[
          ValidationEnum.VALIDATE_SMART_SEARCH,
          ValidationEnum.VALIDATE_SEARCH,
      ]}
      validOnEmpty={false}
      onRefresh={(output, params) => {
        const getReportCurrentInventoryParams: GetReportCurrentInventoryParams =
          {
              name:"Current Inventory",
              output,
          };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getReportCurrentInventoryParams[id] = params.id;
        }

        return getReportCurrentInventory(getReportCurrentInventoryParams);
      }}
    />
  );
};

export default ReportCurrentInventory;
